// extracted by mini-css-extract-plugin
module.exports = {"userBox":"Accounts_userBox__ZLxVq","addButton":"Accounts_addButton__2LHrt"};